import React from 'react';
import styled from 'styled-components';
import { Container, H3, Page } from '@ui';
import { Body } from '@ui';
import { Header } from '@app/navigation/header';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { useLatestCompanyDocs } from '@hooks/features/useLatestCompanyDocs';
import { LatestDocsList } from '@containers/DigitalAnalyst/DocumentList';
import { scrollToTop } from '@utils/usefulFuncs';
import { PageLoading } from '@ui/PageLoading';
import { ROUTES } from '@constants/routes';
import { Loading } from '@ui/Loading';
import { createRows } from '@utils';
import { PageError } from '@ui/PageError';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { fetchTagData } from '@services/docs';

const PageWrapper = styled.div`
  height: 100vh;
`;
const BodyWrapper = styled.div`
  padding: 24px;
`;

function TagDetailDisplay({ data }) {
  const navigate = useNavigate();

  const [rows, setRows] = React.useState([]);
  const { latestDocDays, latestDocsByDayLookup, isLoading: isLoadingDocs, getDocData } = useLatestCompanyDocs();

  React.useEffect(() => {
    if (data?.id) {
      getDocData({ company_ids: [data.id] });
    }
  }, [data]);

  React.useEffect(() => {
    if (Array.isArray(latestDocDays)) {
      setRows(createRows(latestDocDays, latestDocsByDayLookup, []));
    }
  }, [latestDocDays, latestDocsByDayLookup]);

  const onGoBack = () => {
    navigate(ROUTES.home);
  };

  const onQueryNowClick = () => {
    const url = ROUTES.digitalAnalyst + '?tag=' + data?.id;
    window.open(url, '_blank');
  };

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <BodyWrapper>
          <Page>
            <BackArrowButton onClick={onGoBack} />
            <Container row verticallyCenter spaceBetween top={48}>
              <Container>
                {data?.name && (
                  <H3 bold lineHeight={'28px'}>
                    {data?.name}
                  </H3>
                )}
              </Container>
              {/* <Container left={16}>
                <FlatButton onClick={onQueryNowClick}>Query Now</FlatButton>
              </Container> */}
            </Container>

            <Container>
              <Container vertical={24}>
                {isLoadingDocs ? <Loading /> : <LatestDocsList rows={rows} isOneStock />}
              </Container>
            </Container>
          </Page>
        </BodyWrapper>
      </Body>
    </PageWrapper>
  );
}

function TagDetailGetter({ id }) {
  const [data, setData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const getter = async () => {
      const { ok, data } = await fetchTagData(id);
      if (ok) {
        setIsLoading(false);
        setError(null);
        setData(data);
      } else {
        setError('Something went wrong, please refresh the page and try again.');
        setIsLoading(false);
      }
    };
    getter();
  }, [id]);
  if (isLoading) {
    return <PageLoading />;
  }
  if (error) {
    return <PageError error={error} />;
  }
  if (!data) {
    return <PageError message={'No matching tag found.'} />;
  }
  return <TagDetailDisplay data={data} />;
}

export default function TagDetail() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const [tagId, setTagId] = React.useState(null);

  React.useEffect(() => {
    const tagId = searchParams.get('id');
    if (tagId) {
      setTagId(tagId);
    } else {
      navigate(ROUTES.home);
    }
  }, [searchParams]);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  if (tagId !== null) {
    return <TagDetailGetter id={tagId} />;
  }
  return null;
}
